import {
  reopenQcTaskQcTasksReopenPatch,
  ReopenQcTaskQcTasksReopenPatchResponse,
  Body_reopen_qc_task_qc_tasks_reopen_patch,
  HTTPValidationError,
} from '@common/config/api/client'
import { queryClient } from '@common/config/api/queryClient'
import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { AxiosError } from 'axios'

export const useReopenTasksMutation = (): UseMutationResult<
  ReopenQcTaskQcTasksReopenPatchResponse,
  AxiosError<HTTPValidationError>,
  Body_reopen_qc_task_qc_tasks_reopen_patch
> => {
  return useMutation<
    ReopenQcTaskQcTasksReopenPatchResponse,
    AxiosError<HTTPValidationError>,
    Body_reopen_qc_task_qc_tasks_reopen_patch
  >({
    mutationFn: async (body) => {
      const response = await reopenQcTaskQcTasksReopenPatch({
        body: body,
        throwOnError: true,
      })
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['QCTasksList'] })
    },
  })
}
